import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum InvoiceFields {
    TITLE = 'title',
    INVOICE_NUMBER = 'invoiceNumber',
    INVOICE_DATE = 'invoiceDate',
    IS_CANCELED = 'isCanceled',
    DUE_DATE = 'dueDate',
    ITEMS = 'items',
    ACCOUNTING_REF = 'accountingRef',
    PUSHED_TO_ACCOUNTING_AT = 'pushedToAccountingAt',
    NET_TOTAL = 'netTotal',
    GROSS_TOTAL = 'grossTotal',
    VAT_TOTAL = 'vatTotal',
    STUDENT = 'student',
    CYCLE = 'cycle',
    PAID_STATE = 'paidState',
    PAID_AMOUNT = 'paidAmount',
    PAID_DATE = 'paidDate',
    PAYMENT_CHECKED_AT = 'paymentCheckedAt',
    FAST_BILL_STATE = 'fastBillState',
    LOCKED_IN_FAST_BILL = 'lockedInFastBill',
    CANCELLED_IN_FAST_BILL_AT = 'cancelledInFastBillAt',
    FAST_BILL_CREDITS = 'fastBillCredits',
    FAST_BILL_CREDITED_AMOUNT = 'fastBillCreditedAmount',
    SERVICE_PERIOD = 'servicePeriod',
    IS_DRAFT_HOLD = 'isDraftHold',
    HOLD_REASON = 'holdReason',
    DRAFT_HOLD_UNTIL = 'draftHoldUntil',
    ACCOUNTING_LAST_UPDATE = 'accountingLastUpdate',
    ACCOUNTING_MIRROR_PENDING = 'accountingMirrorPending',
    STORNO_ACCOUNTING_REF = 'stornoAccountingRef',
    STORNO_INVOICE_NUMBER = 'stornoInvoiceNumber',
    CANCELED_AT = 'canceledAt',
    CORRECTION_OF = 'correctionOf',
    CORRECTED_BY = 'correctedBy',
    CORRECTION = 'correction',
    EDIT_LOG = 'editLog',
    RUN_ADJUSTMENTS = 'runAdjustments',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace InvoiceFields {
    type Data = {
        text: string;
        readonly?: boolean;
    };

    export const Record: Record<InvoiceFields, Data> = {
        [InvoiceFields.TITLE]: {
            text: 'Titel',
            readonly: true,
        },
        [InvoiceFields.INVOICE_NUMBER]: {
            text: 'Rechnungsnummer',
            readonly: true,
        },
        [InvoiceFields.INVOICE_DATE]: {
            text: 'Rechnungsdatum',
            readonly: true,
        },
        [InvoiceFields.DUE_DATE]: {
            text: 'Fälligkeitsdatum',
            readonly: true,
        },
        [InvoiceFields.ITEMS]: {
            text: 'Rechnungspositionen',
            readonly: true,
        },
        [InvoiceFields.ACCOUNTING_REF]: {
            text: 'Buchhaltungsreferenz',
            readonly: true,
        },
        [InvoiceFields.PUSHED_TO_ACCOUNTING_AT]: {
            text: 'Buchhaltungsdatum',
            readonly: true,
        },
        [InvoiceFields.NET_TOTAL]: {
            text: 'Nettobetrag',
            readonly: true,
        },
        [InvoiceFields.GROSS_TOTAL]: {
            text: 'Bruttobetrag',
            readonly: true,
        },
        [InvoiceFields.VAT_TOTAL]: {
            text: 'Umsatzsteuer',
            readonly: true,
        },
        [InvoiceFields.STUDENT]: {
            text: 'Schüler',
            readonly: true,
        },
        [InvoiceFields.CYCLE]: {
            text: 'Rechnungslauf',
            readonly: true,
        },
        [InvoiceFields.PAID_STATE]: {
            text: 'Zahlungsstatus',
        },
        [InvoiceFields.PAID_AMOUNT]: {
            text: 'Bezahlter Betrag',
        },
        [InvoiceFields.PAID_DATE]: {
            text: 'Bezahlt am (FastBill)',
            readonly: true,
        },
        [InvoiceFields.PAYMENT_CHECKED_AT]: {
            text: 'Zahlstatus abgefragt am',
            readonly: true,
        },
        [InvoiceFields.FAST_BILL_STATE]: {
            text: 'FastBill-Status',
            readonly: true,
        },
        [InvoiceFields.LOCKED_IN_FAST_BILL]: {
            text: 'In FastBill festgeschrieben',
            readonly: true,
        },
        [InvoiceFields.CANCELLED_IN_FAST_BILL_AT]: {
            text: 'In FastBill storniert am (nicht durch Vanilla)',
            readonly: true,
        },
        [InvoiceFields.FAST_BILL_CREDITS]: {
            text: 'Gutschriften / Teilstornos in FastBill',
            readonly: true,
        },
        [InvoiceFields.FAST_BILL_CREDITED_AMOUNT]: {
            text: 'In FastBill gutgeschriebener Betrag',
            readonly: true,
        },
        [InvoiceFields.SERVICE_PERIOD]: {
            text: 'Leistungszeitraum',
            readonly: true,
        },
        [InvoiceFields.IS_DRAFT_HOLD]: {
            text: 'Entwurf zurückgehalten',
            readonly: true,
        },
        [InvoiceFields.HOLD_REASON]: {
            text: 'Grund der Zurückhaltung',
            readonly: true,
        },
        [InvoiceFields.DRAFT_HOLD_UNTIL]: {
            text: 'Zurückgehalten bis',
            readonly: true,
        },
        [InvoiceFields.ACCOUNTING_LAST_UPDATE]: {
            text: 'Letzter Abgleich mit FastBill',
            readonly: true,
        },
        [InvoiceFields.ACCOUNTING_MIRROR_PENDING]: {
            text: 'Abgleich mit FastBill ausstehend',
            readonly: true,
        },
        [InvoiceFields.STORNO_ACCOUNTING_REF]: {
            text: 'Storno-Referenz (FastBill)',
            readonly: true,
        },
        [InvoiceFields.STORNO_INVOICE_NUMBER]: {
            text: 'Stornonummer',
            readonly: true,
        },
        [InvoiceFields.CANCELED_AT]: {
            text: 'Storniert am',
            readonly: true,
        },
        [InvoiceFields.CORRECTION_OF]: {
            text: 'Korrektur von',
            readonly: true,
        },
        [InvoiceFields.CORRECTED_BY]: {
            text: 'Korrigiert durch',
            readonly: true,
        },
        [InvoiceFields.CORRECTION]: {
            text: 'Korrektur (Grund, Schritte, Differenz)',
            readonly: true,
        },
        [InvoiceFields.EDIT_LOG]: {
            text: 'Bearbeitungsprotokoll',
            readonly: true,
        },
        [InvoiceFields.RUN_ADJUSTMENTS]: {
            text: 'Vorab-Anpassungen des Rechnungslaufs',
            readonly: true,
        },
        [InvoiceFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readonly: true,
        },
        [InvoiceFields.UPDATED_AT]: {
            text: 'Änderungsdatum',
            readonly: true,
        },
        [InvoiceFields.IS_CANCELED]: {
            text: 'Storniert',
        },
    };

    export const Items = mapRecordToItems(Record);
}
